<template>
  <div id="whale-entryrules-tab">
    <helpers-section-header class="mt-0 mb-6">
      Configure Entry Rules for Matching Signals:
    </helpers-section-header>

    <v-tabs v-model="tab">
      <v-tab value="1"> Long Positions </v-tab>
      <v-tab v-if="short" value="2"> Short Positions </v-tab>
    </v-tabs>
    <v-tabs-window v-model="tab">
      <v-tabs-window-item value="1">
        <EntryRuleRaw rule-type="long" />
      </v-tabs-window-item>
      <v-tabs-window-item v-if="short" value="2">
        <EntryRuleRaw rule-type="short" />
      </v-tabs-window-item>
    </v-tabs-window>
  </div>
</template>

<script>
// Modules
import { mapWritableState } from 'pinia'
import { useAppStore } from '@/store'
import { markRaw } from 'vue'
// Components
import EntryRule from '@/components/page/whale-backtester/_EntryRule'
const EntryRuleRaw = markRaw(EntryRule)
export default {
  components: {
    EntryRuleRaw
  },
  data() {
    return {
      short: false,
      tab: '1'
    }
  },
  computed: {
    ...mapWritableState(useAppStore, ['whaleTraderCriteria'])
    /* ...mapFields({
      criteria: 'app.whaleTraderCriteria'
    })*/
  }
}
</script>
